import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { DashboardIcon, ProductsIcon, IntegrationsIcon, SettingsIcon, InviteIcon } from './SidebarIcons';
import './Sidebar.css';

const Sidebar = ({ isOpen, onToggle }) => {
  const [expandedMenus, setExpandedMenus] = useState({});

  const toggleSubmenu = (menuKey) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuKey]: !prev[menuKey]
    }));
  };

  const menuItems = [
    {
      key: 'dashboard',
      label: 'Dashboard',
      icon: <DashboardIcon />,
      path: '/dashboard',
    },
    {
      key: 'products',
      label: 'Products',
      icon: <ProductsIcon />,
      submenu: [
        { label: 'Add Product', path: '/products/add' },
        { label: 'View Products', path: '/products' },
      ]
    },
    {
      key: 'integrations',
      label: 'Marketplace Integration',
      icon: <IntegrationsIcon />,
      submenu: [
        { label: 'Shopify', path: '/integrations/shopify' },
        { label: 'eBay', path: '/integrations/ebay' },
        { label: 'Poshmark', path: '/integrations/poshmark' },
      ]
    },
    {
      key: 'settings',
      label: 'Settings',
      icon: <SettingsIcon />,
      submenu: [
        { label: 'eBay Settings', path: '/settings/ebay' },
        { label: 'Shopify Settings', path: '/settings/shopify' },
      ]
    },
    {
      key: 'invite',
      label: 'Invite Users',
      icon: <InviteIcon />,
      path: '/invite-users',
    },
  ];

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div className="sidebar-overlay" onClick={onToggle}></div>
      )}

      {/* Sidebar */}
      <aside className={`sidebar ${isOpen ? 'sidebar-open' : ''}`}>
        {/* Hamburger Toggle Section */}
        <div className="sidebar-header">
          {!isOpen ? (
            <button 
              className="sidebar-hamburger-btn" 
              onClick={onToggle}
              aria-label="Open sidebar"
            >
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </button>
          ) : (
            <div className="sidebar-logo-container" onClick={onToggle}>
              <img 
                src="/images/Thirift Lyst PNG.png" 
                alt="Thirift Lyst Logo" 
                className="sidebar-logo"
              />
            </div>
          )}
        </div>

        {/* Navigation Menu */}
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <div key={item.key}>
              {item.submenu ? (
                // Menu item with submenu
                <>
                  <button
                    className={`sidebar-item sidebar-toggle ${expandedMenus[item.key] ? 'expanded' : ''}`}
                    onClick={() => toggleSubmenu(item.key)}
                  >
                    <span className="sidebar-icon">{item.icon}</span>
                    {isOpen && (
                      <>
                        <span className="sidebar-label">{item.label}</span>
                        <span className="sidebar-arrow">
                          {expandedMenus[item.key] ? '▼' : '▶'}
                        </span>
                      </>
                    )}
                  </button>
                  
                  {expandedMenus[item.key] && isOpen && (
                    <div className="sidebar-submenu">
                      {item.submenu.map((subItem) => (
                        <NavLink
                          key={subItem.path}
                          to={subItem.path}
                          className={({ isActive }) =>
                            `sidebar-subitem ${isActive ? 'active' : ''}`
                          }
                        >
                          {subItem.label}
                        </NavLink>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                // Simple menu item
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `sidebar-item ${isActive ? 'active' : ''}`
                  }
                >
                  <span className="sidebar-icon">{item.icon}</span>
                  {isOpen && <span className="sidebar-label">{item.label}</span>}
                </NavLink>
              )}
            </div>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
